import { apiRequest } from '../api/client';

// Mirror of packages/shared/src/schemas/claude-token.ts ClaudeTokenScope.
// Keep in lockstep; the admin-api rejects any other value with a 400.
export type ClaudeTokenScope = 'read-only' | 'read-and-propose-fix';

export interface ClaudeTokenRequest {
  intent: string;
  scope: ClaudeTokenScope;
  allowAutoMerge: boolean;
}

export interface ClaudeTokenResponse {
  token: string;
  jti: string;
  expiresAt: string;
}

export function issueClaudeToken(req: ClaudeTokenRequest): Promise<ClaudeTokenResponse> {
  return apiRequest<ClaudeTokenResponse>('/claude-tokens', {
    method: 'POST',
    body: JSON.stringify(req),
  });
}
